//This RSS data service will handle how we get the generic news articles that the user/organisation has added
// import firebase from '@/fb'; 
// import moment from 'moment';
// import fbAdmin from 'firebase';

export default class RSSDataService {

}